/**
 * Created by andrey on 01.08.2022
 */

// eslint-disable-next-line
let VictoryMessageAction = function (f) {
    if (Game.currentGame.outcome !== GameBase.OUTCOME_VICTORY) {
        f();
        return;
    }

    if (Game.currentGame.shouldSkipVictoryWindow()) {
        f();
        return;
    }

    cleverapps.effects.fire("game.victory.congratulate");

    const game = Game.currentGame;

    if (["heroes", "runes", "adventure"].includes(cleverapps.config.name)) {
        game.counter.setTimeout(() => {
            cleverapps.exclamation.show("message.YouWin", Exclamation.Types.Congrats, f);
        }, 1300);
        return;
    }

    if (cleverapps.config.type === "board") {
        game.counter.setTimeout(f, 650);
        return;
    }

    game.counter.inc();
    game.showMessage("GameMessage.Victory", () => {
        game.counter.dec();
        f();
    });
};